import React from "react";

import {
    ExpandableSection,
    Badge,
} from "@amzn/awsui-components-react";
import QSMeta from "./QSMeta";
import AlteryxMeta from "./AlteryxMeta";

export default (props) => {

    return (
        <ExpandableSection
            variant="container"
            headerText="Meta"
        >
            {props.data?.process_details?.qs?.length >= 1 && (
                <QSMeta data={props.data?.process_details?.qs}/>
            )}

            { props.data?.process_details?.alteryx?.length >=1 &&(
                <AlteryxMeta data={props.data?.process_details?.alteryx}/>
            )}

            {props.data?.process_details?.python?.length >= 1 && (
                <ExpandableSection headerText="Python">
                    Python data
                </ExpandableSection>
            )}
        </ExpandableSection>
    );
};
